import { useDispatch, useSelector } from "react-redux";
import { toggleAreaDesarrolloPlantelActiveThunk } from "../../../store/reducers/fortalezas/fortalezasPlantel.thunks";
import Modal from "../../UI/Modal";
import Loader from "../../UI/Loader";
import { closeAreaConfirmToggle } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";

const ConfirmToggleAreaModalPlantel = () => {
  const dispatch = useDispatch();
  const { areaConfirmModalOpen, toggleAreaId, areaToggling } = useSelector((state) => state.fortalezasPlantel);
  const area = useSelector((state) => state.fortalezasPlantel.areasList.find((a) => a.id === toggleAreaId));

  return (
    <Modal open={areaConfirmModalOpen} onClose={() => dispatch(closeAreaConfirmToggle())} title="Confirmación" size="sm">
      {areaToggling ? <Loader center text="Actualizando..." type="dots" size="sm" /> : (
        <>
          <p className="mb-3">¿Seguro que quieres <strong>{area?.is_active ? "desactivar" : "activar"}</strong> el área <strong>"{area?.area}"</strong>?</p>
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-secondary" onClick={() => dispatch(closeAreaConfirmToggle())}>Cancelar</button>
            <button className="btn btn-primary" onClick={() => dispatch(toggleAreaDesarrolloPlantelActiveThunk(toggleAreaId))}>Confirmar</button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleAreaModalPlantel;
